import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmService } from '../services/confirm.service';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges()) return true;
  return inject(ConfirmService).open(
    'You have unsaved changes. Leave this page and discard them?',
    { confirmLabel: 'Leave page' }
  );
};

/** The `/…/companies/:id` prefix of a URL, or null when it has none. */
function companyBase(url: string): string | null {
  return url.split(/[?#]/)[0].match(/^.*\/companies\/[^/]+/)?.[0] ?? null;
}

/**
 * unsavedChangesGuard for the admin company tabs: switching to another tab of
 * the same company navigates without asking; leaving the company still asks.
 */
export const companyTabUnsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> =
  (component, currentRoute, currentState, nextState) => {
    const base = companyBase(currentState.url);
    if (base && nextState && companyBase(nextState.url) === base) return true;
    return unsavedChangesGuard(component, currentRoute, currentState, nextState);
  };
